export default "__VITE_ASSET__Cx9vJ7DQ__"